import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";
import { CopyToClipboard } from "@ds-cps/ui";

interface Props {
  baseKey: string;
  baseValue: string;
}

export const SerialNumberKeyValuePair: FC<Props> = props => {
  const { baseKey, baseValue } = props;

  const { t } = useTranslation(undefined, {
    keyPrefix: "common"
  });

  return (
    <>
      <Typography className="self-center">{baseKey}</Typography>
      <div className="flex justify-start gap-2">
        <Typography className="self-center font-bold">
          {baseValue}
          <span className="ml-1 inline-block">
            <CopyToClipboard
              value={baseValue}
              message={t("copied-to-clipboard", {
                entityName: "Serial Number"
              })}
            />
          </span>
        </Typography>
      </div>
    </>
  );
};
